function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Пытается сфокусироваться на первом элементе в списке кандидатов.
 * Останавливается, когда фокус действительно переместился.
 */
export function focusFirst(candidates) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$select = _ref.select,
    select = _ref$select === void 0 ? false : _ref$select;
  var previouslyFocusedElement = document.activeElement;
  var _iterator = _createForOfIteratorHelper(candidates),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var candidate = _step.value;
      focus(candidate, {
        select: select
      });
      if (document.activeElement !== previouslyFocusedElement) {
        return;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 * Возвращает первый и последний элементы, доступные для табуляции, внутри контейнера.
 */
export function getTabbableEdges(container) {
  var candidates = getTabbableCandidates(container);
  var first = findVisible(candidates, container);
  var last = findVisible(candidates.reverse(), container);
  return [first, last];
}
/**
 * Возвращает список потенциальных кандидатов для табуляции.
 *
 * ПРИМЕЧАНИЕ: Это только приблизительное значение. Например, он не учитывает случаи, когда
 * элементы не видны. Это нельзя легко определить, просто прочитав свойство, но необходимо
 * знание времени выполнения (вычисленные стили и т. д.). Мы рассматриваем эти случаи отдельно.
 *
 * См.: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Кредит: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */
export function getTabbableCandidates(container) {
  var nodes = [];
  var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    acceptNode: function acceptNode(node) {
      var isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
      if (node.disabled || node.hidden || isHiddenInput) {
        return NodeFilter.FILTER_SKIP;
      }

      // `.tabIndex` не то же самое, что атрибут `tabindex`. Он работает на
      // понимании времени выполнения возможности табуляции, поэтому это автоматически учитывает
      // любой тип элемента, к которому можно перейти с помощью табуляции.
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }

  // мы не учитываем порядок узлов с положительным `tabIndex`, так как это
  // ухудшает доступность, если порядок табуляции отличается от визуального порядка.
  return nodes;
}
/**
 * Возвращает первый видимый элемент в списке.
 * ПРИМЕЧАНИЕ: Проверяет видимость только до уровня `container`.
 */
function findVisible(elements, container) {
  var _iterator2 = _createForOfIteratorHelper(elements),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var element = _step2.value;
      // мы прекращаем проверку, если он скрыт на уровне `container` (исключая его)
      if (!isHidden(element, {
        upTo: container
      })) {
        return element;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return undefined;
}
function isHidden(_node, _ref2) {
  var upTo = _ref2.upTo;
  var node = _node;
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  while (node) {
    // мы останавливаемся на `upTo` (исключая его)
    if (upTo !== undefined && node === upTo) {
      return false;
    }
    if (getComputedStyle(node).display === 'none') {
      return true;
    }
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && 'select' in element;
}
export function focus(element) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$select = _ref3.select,
    select = _ref3$select === void 0 ? false : _ref3$select;
  // фокусируемся только если этот элемент можно сфокусировать
  if (element && element.focus) {
    var previouslyFocusedElement = document.activeElement;
    // ПРИМЕЧАНИЕ: мы предотвращаем прокрутку при фокусировке, чтобы минимизировать резкие переходы для пользователей
    element.focus({
      preventScroll: true
    });
    // выбираем только если это не тот же элемент, он поддерживает выбор и нам нужно выбрать
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select) {
      element.select();
    }
  }
}